import { useLocation } from "react-router-dom";
import { useRef, useEffect } from "react";

const usePreviousRoute = () => {
  const location = useLocation();
  const prevLocationRef = useRef(null);

  useEffect(() => {
    prevLocationRef.current = location;
  }, [location]);

  return prevLocationRef.current;
};

export default usePreviousRoute;
